import { render, staticRenderFns } from "./TrafficLights.vue?vue&type=template&id=6a03b406&scoped=true&"
import script from "./TrafficLights.vue?vue&type=script&lang=js&"
export * from "./TrafficLights.vue?vue&type=script&lang=js&"
import style0 from "./TrafficLights.vue?vue&type=style&index=0&id=6a03b406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a03b406",
  null
  
)

export default component.exports